import { render, staticRenderFns } from "./DefaultSettings.vue?vue&type=template&id=5bc6c566&scoped=true&"
import script from "./DefaultSettings.vue?vue&type=script&lang=ts&"
export * from "./DefaultSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc6c566",
  null
  
)

export default component.exports